import { filter } from 'lodash-es'

export const planDateFormatter = new Intl.DateTimeFormat('de-DE')

/** Dated plans grouped by day (`YYYY-MM-DD`), days and plans within a day in ascending order. */
export const groupPlansByDate = (plans: Plan[]): [string, Plan[]][] => {
  const withDate = filter(plans, plan => plan.date != null)
  const groups = new Map<string, Plan[]>()
  withDate.forEach(plan => {
    const key = (plan.date as string).substring(0, 10)
    const group = groups.get(key)
    if (group) {
      group.push(plan)
    } else {
      groups.set(key, [plan])
    }
  })
  groups.forEach(group => group.sort((a, b) => (a.date as string).localeCompare(b.date as string)))
  return Array.from(groups.entries()).sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
}
